import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const SearchAndFilter = ({ searchTerm, onSearchChange, filterCategory, onFilterChange, onDeleteAll }) => {
  const categoryOptions = [
    { value: '', label: 'All Categories' },
    { value: 'Fresh', label: 'Fresh' },
    { value: 'Refrigerated', label: 'Refrigerated' },
    { value: 'Proteins', label: 'Proteins' },
    { value: 'Canned', label: 'Canned' },
    { value: 'Dry', label: 'Dry' },
    { value: 'Snack', label: 'Snack' },
    { value: 'Condiment', label: 'Condiment' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="relative">
          <Input
            type="search"
            placeholder="Search items..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e?.target?.value)}
          />
          <Icon 
            name="Search" 
            size={18} 
            className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
          />
        </div>

        <div className="flex gap-2">
          <Select
            placeholder="Filter by category"
            options={categoryOptions}
            value={filterCategory}
            onChange={onFilterChange}
            className="flex-1"
          />
          <Button
            variant="destructive"
            onClick={onDeleteAll}
            className="whitespace-nowrap"
          >
            <Icon name="Trash2" size={16} className="mr-2" />
            Delete All Inventory
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SearchAndFilter;